export const Formatter = {
  toCurrency(value, currency = 'UAH', locale = 'uk-UA') {
    const number = Number(value);
    if (isNaN(number)) return 'N/A';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(number);
  },

  toNumber(value, locale = 'uk-UA') {
    const number = Number(value);
    if (isNaN(number)) return 'N/A';

    return number.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  },

  toHryvniaText(value) {
    const number = Number(value);
    if (isNaN(number)) return 'N/A';

    return `${number.toLocaleString('uk-UA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} грн`;
  }
};
